export const nombreCompleto = (matricula) => {
  const nombres = matricula?.estudianteNombres || "";
  const apellidos = matricula?.estudianteApellidos || "";
  const full = `${nombres} ${apellidos}`.trim();
  return full || matricula?.estudiante || "Sin nombre";
};

export const normalizeMatricula = (item = {}) => {
  return {
    id: item.id,
    estudianteId: item.estudiante_id ?? item.estudianteId,
    estudianteNombres: item.estudiante_nombres ?? item.estudianteNombres,
    estudianteApellidos: item.estudiante_apellidos ?? item.estudianteApellidos,
    documentoIdentidad:
      item.estudiante_documento ?? item.documento_identidad ?? item.documentoIdentidad ?? item.documento,
    codigoMatricula: item.codigo_matricula ?? item.codigoMatricula ?? "",
    secuencialCurso: item.secuencial_curso ?? item.secuencialCurso ?? "",
    cicloId: item.ciclo_id ?? item.cicloId ?? null,
    cicloLabel: [item.ciclo_anio ?? item.cicloAnio, item.ciclo_codigo ?? item.cicloCodigo].filter(Boolean).join(" | ") || (item.ciclo_nombre ?? item.cicloNombre ?? item.cicloLabel ?? null),
    promocionId: item.promocion_id ?? item.promocionId,
    cursoId: item.curso_id ?? item.cursoId,
    subtipoCursoId: item.subtipo_curso_id ?? item.subtipoCursoId ?? null,
    promocion: item.promocion || "",
    curso: item.curso || "",
    centro: item.centro || "",
    fechaMatricula: item.fecha_matricula ?? item.fechaMatricula,
    estadoMatricula: item.estado_matricula ?? item.estadoMatricula,
    estadoPago: item.estado_pago ?? item.estadoPago,
    modalidad: item.modalidad ?? 'presencial',
    referenciaPago: item.referencia_pago ?? item.referenciaPago ?? "",
    descuentoIndividual: Number(item.descuento_individual ?? item.descuentoIndividual ?? 0) || 0,
    descuentoIndividualMonto:
      Number(item.descuento_individual_monto ?? item.descuentoIndividualMonto ?? 0) || 0,
    descPromocionPorcentaje: Number(item.desc_promocion_porcentaje ?? item.descPromocionPorcentaje ?? 0) || 0,
    descPromocionMonto: Number(item.desc_promocion_monto ?? item.descPromocionMonto ?? 0) || 0,
    precioLista: Number(item.precio_lista ?? item.precioLista ?? 0) || 0,
    subtotal: Number(item.subtotal ?? item.subTotal ?? 0) || 0,
    totalAPagar: Number(item.total_a_pagar ?? item.totalAPagar ?? 0) || 0,
    saldo: Number(item.saldo ?? item.saldoPendiente ?? 0) || 0,
    observaciones: item.observaciones || "",
    activo: Boolean(
      item.activo === 0 || item.activo === "0" ? false : item.activo ?? true
    ),
    createdAt: item.created_at ?? item.createdAt,
    updatedAt: item.updated_at ?? item.updatedAt,
  };
};
